import React from "react";
import { useRoutes, Navigate } from "react-router-dom";
import Community from "./pages/Community";
import ContactForm from "./pages/ContactForm";
import Admin from "./pages/Admin";
import LaunchedLanding from "./pages/LaunchedLanding";
import "./index.scss";
// import AdminLogin from "./pages/AdminLogin";
// import Navbar from "./components/Navbar";
export default function App() {
  const routes = useRoutes([
    {
      path: "/",
      element: <LaunchedLanding />,
    },
    {
      path: "/join-community",
      element: <ContactForm />,
    },
    {
      path: "/community",
      element: <Community />,
    },
    {
      path: "/admin",
      element: <Admin />,
    },
    {
      path: "*",
      element: <Navigate to="/" />,
    },
  ]);

  // const adminRoutes = useRoutes([
  //   {
  //     path: "/",
  //     element: <Landing />,
  //   },
  //   {
  //     path: "/join-community",
  //     element: <ContactForm />,
  //   },
  //   {
  //     path: "/community",
  //     element: <Community />,
  //   },
  //   {
  //     path: "/admin",
  //     element: <Admin />,
  //   },
  //   {
  //     path: "/admin/login",
  //     element: <AdminLogin />,
  //   },
  //   {
  //     path: "*",
  //     element: <Navigate to="/" />,
  //   },
  // ]);
  // const isAdmin = localStorage.getItem("obfuscation");
  return (
    <>
      {/* <Navbar /> */}
      {/* {isAdmin ? adminRoutes : routes} */}
      {routes}
    </>
  );
}
